import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { RxComposite } from '@nrwl/rx-forms';
import { ImageProperty } from 'libs/rx-form-builder/src/lib/models';
import { RxButtonModule } from 'libs/rx-ui/src/lib/rx-button/rx-button.module';
import { RxIconModule } from 'libs/rx-ui/src/lib/rx-icon/rx-icon.module';
import { RxSignatureComponent } from 'libs/rx-ui/src/lib/rx-signature/rx-signature.component';
import { RxSignatureModule } from 'libs/rx-ui/src/lib/rx-signature/rx-signature.module';

import { take } from 'rxjs';

@Component({
  selector: 'sign-dialog',
  templateUrl: './sign-dialog.component.html',
  styleUrls: ['./sign-dialog.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RxIconModule,
    RxButtonModule,
    MatMenuModule,
    RxSignatureModule,
  ],
})
export class SignDialogComponent extends RxComposite implements OnInit, AfterViewInit {
  @ViewChild('signature') signature: RxSignatureComponent;

  constructor() {
    super();
  }

  ngOnInit() {}

  ngAfterViewInit() {
    //after initialized signature component draw signature
    this.signature.initialized.pipe(take(1)).subscribe(() => {
      if (this.payload?.signature) {
        this.signature.fromDataURL(this.payload.signature);
      }
    });
  }

  public onSubmitClicked() {}

  public onDrawingComplete($event) {
    const base64 = this.signature.toDataURL();
    this.payload.signature = base64;
  }

  public onClearSignatureClicked() {
    this.signature.clear();
    const defaultImg = new ImageProperty();
    this.payload.signature = defaultImg.value;
    this.signature.fromDataURL(this.payload.signature);
  }

  public signFormClicked() {
    this.dialog.submitClicked(this.payload);
  }

  public closeClicked() {
    this.dialog.close();
  }
}
